import { IListDto } from "../../../interface/dto/list.dto";
import { IListSearchAction, ListSearchActionType } from "./list-search.actions";

export interface IListSearchState {
    text: string;
    isLoading: boolean;
    error?: string;
    lists?: Array<IListDto>;
}

const initState: IListSearchState = {
    text: "",
    isLoading: false,
    lists: undefined,
};

export const listSearchReducer = (
    state = initState,
    action: IListSearchAction,
) => {
    switch (action.type) {
        case ListSearchActionType.LIST_SEARCH_GET:
            return {
                ...state,
                isLoading: true,
                error: undefined,
                lists: undefined,
            };
        case ListSearchActionType.LIST_SEARCH_GET_ERROR:
            return { ...state, error: action.payload.error, isLoading: false };
        case ListSearchActionType.LIST_SEARCH_GET_SUCCESS:
            return { ...state, lists: action.payload.lists, isLoading: false };
        default:
            return state;
    }
};
